export default "__VITE_ASSET__$dFFAPbX__"